// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/util/tendermint_proxy/v1/tendermint_proxy.proto (package penumbra.util.tendermint_proxy.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { DefaultNodeInfo } from "@buf/cosmos_cosmos-sdk.bufbuild_es/tendermint/p2p/types_pb.js";
import { Validator } from "@buf/cosmos_cosmos-sdk.bufbuild_es/tendermint/types/validator_pb.js";
import { ProofOps } from "@buf/cosmos_cosmos-sdk.bufbuild_es/tendermint/crypto/proof_pb.js";
import { BlockID } from "@buf/cosmos_cosmos-sdk.bufbuild_es/tendermint/types/types_pb.js";
import { Block } from "@buf/cosmos_cosmos-sdk.bufbuild_es/tendermint/types/block_pb.js";

/**
 * GetTxRequest is the request type for the GetTx RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetTxRequest
 */
export const GetTxRequest = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.GetTxRequest",
  () => [
    { no: 1, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "prove", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * GetTxResponse is the response type for the GetTx RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetTxResponse
 */
export const GetTxResponse = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.GetTxResponse",
  () => [
    { no: 1, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "tx_result", kind: "message", T: TxResult },
    { no: 5, name: "tx", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.util.tendermint_proxy.v1.TxResult
 */
export const TxResult = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.TxResult",
  () => [
    { no: 1, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gas_wanted", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "gas_used", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "tags", kind: "message", T: Tag, repeated: true },
  ],
);

/**
 * @generated from message penumbra.util.tendermint_proxy.v1.Tag
 */
export const Tag = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.Tag",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "index", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * BroadcastTxAsyncRequest is the request type for the BroadcastTxAsync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncRequest
 */
export const BroadcastTxAsyncRequest = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncRequest",
  () => [
    { no: 1, name: "params", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "req_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * BroadcastTxAsyncResponse is the response type for the BroadcastTxAsync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncResponse
 */
export const BroadcastTxAsyncResponse = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.BroadcastTxAsyncResponse",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * BroadcastTxSyncRequest is the request type for the BroadcastTxSync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxSyncRequest
 */
export const BroadcastTxSyncRequest = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.BroadcastTxSyncRequest",
  () => [
    { no: 1, name: "params", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "req_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * BroadcastTxSyncResponse is the response type for the BroadcastTxSync RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.BroadcastTxSyncResponse
 */
export const BroadcastTxSyncResponse = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.BroadcastTxSyncResponse",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * GetStatusRequest is the request type for the Query/GetStatus RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetStatusRequest
 */
export const GetStatusRequest = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.GetStatusRequest",
  [],
);

/**
 * GetStatusResponse is the response type for the Query/GetStatus RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetStatusResponse
 */
export const GetStatusResponse = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.GetStatusResponse",
  () => [
    { no: 1, name: "node_info", kind: "message", T: DefaultNodeInfo },
    { no: 2, name: "sync_info", kind: "message", T: SyncInfo },
    { no: 3, name: "validator_info", kind: "message", T: Validator },
  ],
);

/**
 * @generated from message penumbra.util.tendermint_proxy.v1.SyncInfo
 */
export const SyncInfo = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.SyncInfo",
  () => [
    { no: 1, name: "latest_block_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "latest_app_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "latest_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "latest_block_time", kind: "message", T: Timestamp },
    { no: 9, name: "catching_up", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * ABCIQueryRequest defines the request structure for the ABCIQuery gRPC query.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.ABCIQueryRequest
 */
export const ABCIQueryRequest = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.ABCIQueryRequest",
  () => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "prove", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * ABCIQueryResponse defines the response structure for the ABCIQuery gRPC query.
 *
 * Note: This type is a duplicate of the ResponseQuery proto type defined in
 * Tendermint.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.ABCIQueryResponse
 */
export const ABCIQueryResponse = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.ABCIQueryResponse",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "index", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proof_ops", kind: "message", T: ProofOps },
    { no: 9, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "codespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * GetBlockByHeightRequest is the request type for the Query/GetBlockByHeight RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetBlockByHeightRequest
 */
export const GetBlockByHeightRequest = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.GetBlockByHeightRequest",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * GetBlockByHeightResponse is the response type for the Query/GetBlockByHeight RPC method.
 *
 * @generated from message penumbra.util.tendermint_proxy.v1.GetBlockByHeightResponse
 */
export const GetBlockByHeightResponse = proto3.makeMessageType(
  "penumbra.util.tendermint_proxy.v1.GetBlockByHeightResponse",
  () => [
    { no: 1, name: "block_id", kind: "message", T: BlockID },
    { no: 2, name: "block", kind: "message", T: Block },
  ],
);

